import router from '@/router'

export default {
  name: 'HomePage',
  components: {
  },
  data () {
    return {
      hiddenBanner: true
    }
  },
  mounted () {
    this.displayBanner()
  },
  methods: {
    displayBanner() {
      setTimeout(() => this.hiddenBanner = false, 300);
    },
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    }
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/homepage/homepage.component.js